var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSubscribers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    rx: 17,
    ry: 16.5,
    transform: "matrix(-1 0 0 1 17.667 28.4153)",
    fill: "#FDCB6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8569 12.0943C44.8138 11.9902 44.75 11.8928 44.6655 11.8082C44.5809 11.7237 44.4835 11.6599 44.3794 11.6168C44.2755 11.5737 44.1614 11.5499 44.0419 11.5499H35.2225C34.7354 11.5499 34.3405 11.9448 34.3405 12.4318C34.3405 12.9189 34.7354 13.3138 35.2225 13.3138H41.9127L30.5545 24.672C30.2101 25.0164 29.6516 25.0164 29.3072 24.672L24.7462 20.111C23.713 19.0777 22.0377 19.0777 21.0045 20.111L11.6685 29.447C11.3241 29.7914 11.3241 30.3498 11.6685 30.6942C12.0129 31.0386 12.5713 31.0386 12.9157 30.6942L22.2517 21.3582C22.5961 21.0138 23.1546 21.0138 23.499 21.3582L28.06 25.9192C29.0932 26.9525 30.7685 26.9525 31.8017 25.9192L43.1599 14.561V21.2512C43.1599 21.7383 43.5548 22.1332 44.0419 22.1332C44.5289 22.1332 44.9238 21.7383 44.9238 21.2512V12.4318C44.9238 12.3123 44.9 12.1982 44.8569 12.0943Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSubscribers);
export default __webpack_public_path__ + "static/media/new-subscribers.37651e063807233d9fe646127293d987.svg";
export { ForwardRef as ReactComponent };